import React, { useState } from 'react';

import { Row, Col, Button } from 'react-bootstrap';
import Select from 'components/inputs/Select';
import ButtonList from 'components/inputs/ButtonList';
import SkyPulseTable from 'components/SkyPulseTable';
import DatePicker from 'components/inputs/DatePicker';

import styles from './styles.module.css';

const idPrefix = 'UsageAudioAlbums';

const columnDefinitions = [
  {
    name: 'Rank',
    key: 'rank',
    size: 'xsmall',
    dataCyClassName: 'Usage-AudioAlbumsTableColumn-rank',
  },
  {
    name: 'Content ID',
    key: 'content_id',
    size: 'large',
    dataCyClassName: 'Usage-AudioAlbumsTableColumn-contentId',
  },
  {
    name: 'Views',
    key: 'views',
    size: 'xsmall',
    dataCyClassName: 'Usage-AudioAlbumsTableColumn-views',
  },
  {
    name: 'Avg view mins',
    key: 'avg_views_min',
    size: 'small',
    sortable: true,
    dataCyClassName: 'Usage-AudioAlbumsTableColumn-avgViewsMin',
  },
  {
    name: 'Content mins',
    key: 'content_mins',
    size: 'xsmall',
    sortable: true,
    dataCyClassName: 'Usage-AudioAlbumsTableColumn-rank',
  },
];

const data = [
  {
    rank: '1',
    content_id: 'DFP_0623_27Dresses',
    views: 69020,
    avg_views_min: 104,
    content_mins: 122,
  },
];

const AudioAlbums = () => {
  const [selectedEventFilter, setSelectedEventFilter] = useState('last30Days');
  const [selectedMonth, setSelectedMonth] = useState('january2026');

  const months = [
    { name: 'January 2026', id: 'january2026' },
    { name: 'February 2026', id: 'february2026' },
    { name: 'March 2026', id: 'march2026' },
    { name: 'April 2026', id: 'april2026' },
    { name: 'May 2026', id: 'may2026' },
  ];

  const filterOptions = [
    { name: 'Last 30 days', value: 'last30Days' },
    {
      name: (
        <div>
          <Select
            idPrefix={`${idPrefix}-month`}
            data-cy-id={`${idPrefix}-FiltersPanel-month`}
            label="Month: "
            options={months}
            value={selectedMonth}
            onChange={({ target: { value } }) => setSelectedMonth(value)}
          />
        </div>
      ),
      value: 'month',
    },
    {
      name: (
        <div className={styles.datecontainer}>
          <div>
            <DatePicker
              idPrefix={`${idPrefix}-FilterPanel-from`}
              value={Date.now()}
              label="From:"
              onChange={() => {}}
            />
          </div>
          <div>
            <DatePicker
              idPrefix={`${idPrefix}-FilterPanel-to`}
              value={Date.now()}
              label="To:"
              onChange={() => {}}
            />
          </div>
        </div>
      ),
      value: 'dateRange',
    },
  ];

  return (
    <Row className={styles.root} noGutters>
      <Col>
        <Row className={styles.title} noGutters>
          <Col data-cy-id="Usage-AudioAlbums-Header" className="title_1">
            Audio albums
          </Col>
        </Row>
        <Row className={styles.filterContainer} noGutters>
          <Col>
            <ButtonList
              key={selectedEventFilter}
              idPrefix="Events-filter"
              name="eventFilters"
              type="radio"
              onChange={(e) => {
                const { value } = e.target;
                setSelectedEventFilter(value);
              }}
              options={filterOptions}
              value={selectedEventFilter}
              arrangementClassName={styles.filterList}
              classname={styles.options}
            />
          </Col>
          <Col md="auto">
            <Button
              className="button_foc"
              data-cy-id="Usage-AudioAlbums-FilterButton"
              onClick={() => {}}
            >
              Filter
            </Button>
          </Col>
        </Row>
        <Row className={styles.dataContainer} noGutters>
          <Col className="h-100">
            <Row className={styles.tableContainer} noGutters>
              <Col className="h-100">
                <SkyPulseTable
                  columns={columnDefinitions}
                  rows={data}
                  title="Last 30 days"
                  onRowClick={() => {}}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default AudioAlbums;
